let config = require("./config");

let knex = require("knex")(config[process.env.NODE_ENV]);

let bookshelf = require("bookshelf")(knex);

// NOTE: additional functionalities for the default bookshelf model class
var modelPrototype = bookshelf.Model.prototype;
bookshelf.Model = bookshelf.Model.extend({
  // NOTE: insert or update
  upsert(attributes, options = {}) {
    return this.save(attributes, Object.assign({ method: "update" }, options)).catch(err => {
      // ???: err instanceof bookshelf.Model.NoRowsUpdatedError :: doesn't work
      if (err.message == "No Rows Updated") {
        return this.save(attributes, Object.assign({ method: "insert" }, options));
      }
      throw err;
    });
  },

  // ???: will apply only for the models that don't have a format funtion declared in them
  format(attrs) {
    delete attrs["$id"];

    return attrs;
  },
});

module.exports = bookshelf;
